import Page from 'components/pages/studio-id'
import requestInit from 'request/studio-id/init'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  try {
    const studioId = parseInt(params.id)
    if (!studioId) throw Error('no id')
    const initData = await requestInit({ studioId })
    if (!initData.studio) throw Error('not valid id')
    return { props: { ...initData }, revalidate: 60 * 30 }
  } catch (err){
    return { notFound: true }
  }
}

export default function StudioId(initData) {
  const t = useI18n()
  const { studio } = initData
  const description = studio.description.noNewLine()
  const title = t.seo.title('custom', { value: studio.name })
  const ogImage = fetchOgImage(studio)
  const url = h.path.full.studio({ id: studio.id })
  const year = dayjs().year()
  const rating = {}
  if (studio.totalRatingCount) {
    rating.aggregateRating = {
      '@type': 'AggregateRating',
      'ratingValue': studio.rating,
      'reviewCount': studio.totalRatingCount
    }
  }

  return (
    <>
      <C.Head>
        { h.seo({ title, description })}
        { h.og({ image: ogImage }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'HairSalon',
          'name': studio.name,
          'url': url,
          'description': description,
          'telephone': studio.phone,
          'address': studio.address,
          'priceRange': '$',
          'openingHours': studio.openTime,
          'logo': studio.logoUrl,
          'image': ogImage.url,
          'geo': {
            '@type': 'GeoCoordinates',
            'latitude': studio.lat,
            'longitude': studio.lng
          },
          ...rating
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            'position': 1,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.root(),
              'name': 'StyleMap'
            }
          }, {
            'position': 2,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.studios(),
              'name': t('seo:studios.title', { year })
            }
          }, {
            'position': 3,
            '@type': 'ListItem',
            'item': {
              '@id': url,
              'name': studio.name
            }
          }]
        }) }
      </C.Head>
      <Page { ...initData } />
    </>
  )
}

const fetchOgImage = studio => {
  const { bannerUrl, logoUrl } = studio
  if (bannerUrl) return {
    url: bannerUrl,
    width: 1200,
    height: 628
  }

  return {
    url: logoUrl,
    width: 512,
    height: 512
  }
}
